'use es6';

import { AD_OBJECT_AD_CAMPAIGN } from 'reference-resolvers/constants/ReferenceObjectTypes';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { ADS_CAMPAIGNS } from 'reference-resolvers/constants/CacheKeys';
import { createFetchAdsObjectSearchPage, createFetchAdsObjectsByIds, fetchAdsObjectsByIds, fetchAdsObjectSearchPage } from 'reference-resolvers/api/AdsEntityApi';
export const createAdsCampaignsReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: ADS_CAMPAIGNS,
  createFetchByIds: opts => createFetchAdsObjectsByIds(opts)(AD_OBJECT_AD_CAMPAIGN),
  createFetchSearchPage: opts => createFetchAdsObjectSearchPage(opts)(AD_OBJECT_AD_CAMPAIGN),
  fetchByIds: fetchAdsObjectsByIds(AD_OBJECT_AD_CAMPAIGN),
  fetchSearchPage: fetchAdsObjectSearchPage(AD_OBJECT_AD_CAMPAIGN)
}, options));
export default createAdsCampaignsReferenceResolver();